import { render } from "./SlideOutErrors.vue?vue&type=template&id=3f048c9a"
import script from "./SlideOutErrors.vue?vue&type=script&lang=js"
export * from "./SlideOutErrors.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__